module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp23_7005.c33a8b6c.png";